import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import * as Constants from "../../lib/constants";

import { getGooglePlayURLFromAppID, getAppStoreURLFromAppID } from "../../lib/helpers";

import * as styles from "./AppDownload.module.css";

const AppDownload = ({ language }) => {
  let urlIOS = Constants.URL_DEVELOPER_PAGE_IOS;
  let urlAndroid = Constants.URL_DEVELOPER_PAGE_ANDROID;

  if (language) {
    const app = Constants.AVAILABLE_APPS.find((item) => item.title === language);

    urlIOS = app && app.iosID && getAppStoreURLFromAppID(app.iosID);
    urlAndroid = app && app.androidID && getGooglePlayURLFromAppID(app.androidID);
  }

  return (
    <div className={styles.container}>
      <h2>Download Tobo{language ? ` ${language}` : ""} App</h2>
      <div className={styles.downloadButtonsContainer}>
        {urlIOS && (
          <a href={urlIOS}>
            <img src="/download-app-store.svg" alt="Download Tobo IOS App" />
          </a>
        )}
        {urlAndroid && (
          <a href={urlAndroid}>
            <img src="/download-google-play.svg" alt="Download Tobo IOS App" />
          </a>
        )}
      </div>
    </div>
  );
};

export default AppDownload;
